/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { toAbsoluteUrl } from "../../../../../../_metronic/_helpers";
import * as handlers from "../../../../Instrument/_redux/instruments/instrumentsHandlers"
import cogoToast from "cogo-toast";
import { debounce } from "../../../../../util/Helpers";
import { AsideMenu } from "../AsideMenu";
import { SearchBar } from "../../SearchBar";

export function InstrumentsMenu({ destination = "/instruments" }) {

    const instruments = useSelector(({ instruments }) => instruments, shallowEqual);

    const dispatch = useDispatch();

    /* Instrument Search Input */
    const searchInstrument = e => {
        const query = e.target.value.trim();
        if (query !== "") {
            dispatch(handlers.searchInstruments(query));
        }
    }
    /* Notification Pop up */
    useEffect(() => {
        if (instruments.notification) {
            cogoToast[instruments.notification.type](instruments.notification.message);
            dispatch(handlers.clearNotification());
        }
    });

    return (
        <>
            <SearchBar
                placeholder={"Search Instruments"}
                isLoading={instruments.isLoading}
                onInput={debounce(searchInstrument, 1000)}
            />

            {/* begin::Menu Nav */}
            {instruments.data.map((instrument, i) => (
                <AsideMenu.NavItem to={`${destination}/${instrument?.instrumentId}`} key={i}>
                    <div className="d-flex align-items-center">
                        <span
                            style={{
                                height: "40px",
                                width: "40px",
                            }}
                            className="mr-3 border svg-icon menu-icon rounded-circle bg-white d-flex align-items-center justify-content-center"
                        >
                            <img
                                alt={instrument.symbol[0]}
                                height="25px"
                                width="25px"
                                src={instrument.imageUrl}
                                onError={e => {
                                    e.target.onerror = null;
                                    e.target.src = toAbsoluteUrl("/media/svg/icons/Shopping/Box3.svg")
                                }}
                            />
                        </span>
                        <div className="flex-column align-items-start">
                            <div>
                                {`${instrument.symbol}`.substring(0, 20)}
                            </div>
                            <div className="text-muted">
                                {instrument.name.substring(0, 20)}
                            </div>
                        </div>
                    </div>
                </AsideMenu.NavItem>
            ))}
            {/* end::Menu Nav */}
        </>
    );
}
